const parseNode = (node = {}) => {
    console.log('node::: ', node);
    return (
        {
            ...node,
            cid: parseInt(node.cid),
            oid: parseInt(node.oid),
            prev_ref: parseInt(node.prev_ref),
            prev_refs: parseInt(node.prev_refs),
            level: parseInt(node.level),
            position: parseInt(node.position)
        }
    )
}

export function buildTree(list = []) {
    let map = {},
        prevNode,
        node,
        roots = [],
        i,
        newNode,
        cid = -1

    list.sort((a, b) => parseInt(a.prev_ref) - parseInt(b.prev_ref))

    for (i = 0; i < list.length; i += 1) {
        map[list[i].oid] = i
        list[i].children = []
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]
        if (parseInt(node.cid) != cid) {
            newNode = {
                coursetitle: node.coursetitle,
                title: node.coursetitle,
                oid: i,
                cid: parseInt(node.cid),
                children: [],
            }

            newNode.children.push(parseNode(node))
            roots.push(newNode)
        } else {
            if (parseInt(node.prev_ref) !== -1) {
                if (parseInt(list[map[node.prev_ref]]?.level) < parseInt(node?.level)) {
                    list[map[node.prev_ref]].children.push(parseNode(node))
                    prevNode = list[map[node.prev_ref]]
                } else {
                    if (prevNode) {
                        prevNode.children.push(parseNode(node))
                    } else {
                        newNode.children.push(parseNode(node))
                        prevNode = node
                    }
                }
            } else {
                prevNode = node
                newNode.children.push(parseNode(node))
            }
        }
        cid = parseInt(node.cid)
    }
    return roots?.[0]?.children || []
}

export function buildHierarchy(list = []) {
    if (!list.length) return []

    const map = new Map()
    list.forEach(item => {
        map.set(item.oid, { ...item, children: [] })
    })

    const roots = []
    list.forEach(item => {
        const node = map.get(item.oid)
        const parent = map.get(item.prev_ref)
        if (parent) {
            parent.children.push(node)
        } else {
            roots.push(node)
        }
    })

    const sortByPosition = (nodes) => {
        nodes.sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
        nodes.forEach(node => sortByPosition(node.children))
    }
    sortByPosition(roots)

    return roots
}

export function getDataForUpdate(list = [], parentRef = -1) {
    return list.reduce((acc, node, index) => {
        const { children, isEditing, _localId, ...rest } = node
        const flatNode = { ...rest, prev_ref: parentRef, prev_refs: String(parentRef), position: index }
        const childNodes = children?.length ? getDataForUpdate(children, node.oid ?? null) : []
        return [...acc, flatNode, ...childNodes]
    }, [])
}